import _classCallCheck from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.array.concat.js";
var Watermark = /*#__PURE__*/function () {
  // eslint-disable-next-line no-useless-constructor
  function Watermark(options) {
    _classCallCheck(this, Watermark);
    this.init(options);
    // 图片base64
    this.imageUrl = this.createImg();
    // 水印dom
    this.waterDom = this.createDom();
    // 全局添加
    document.body.appendChild(this.waterDom);
    // 监听改动
    this.watcherDelWaterDom();
    this.watch();
  }
  _createClass(Watermark, [{
    key: "init",
    value: function init(options) {
      this.text = options.text || 'water mark';
      this.style = options.style || '';
      // 旋转角度
      this.rotate = options.rotate || -20;
      // 字体大小
      this.fontSize = options.fontSize || 16;
    }

    // 生成水印图片
  }, {
    key: "createImg",
    value: function createImg() {
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      canvas.style.marginLeft = '300px';
      canvas.style.background = '#ccc';
      var textWidth = this.computerWidth({
        text: this.text,
        fontSize: "".concat(this.fontSize, "px")
      });
      this.computerSide(textWidth);
      var padding = this.fontSize + 40;
      // 计算宽度
      canvas.width = this.width + padding;
      canvas.height = this.height + padding + 180;
      ctx.beginPath();
      ctx.translate(canvas.width / 2, canvas.height / 2);
      ctx.rotate(-20 * Math.PI / 180);
      ctx.font = "".concat(this.fontSize, "px arial");
      ctx.fillText(this.text, -canvas.width / 2 - canvas.width * 0.016, 4);
      ctx.closePath();
      return canvas.toDataURL('image/png');
    }
  }, {
    key: "computerWidth",
    value: function computerWidth(option) {
      var dom = document.createElement('span');
      dom.style.display = 'inline-block';
      dom.style.fontSize = option.fontSize || '16px';
      dom.innerText = option.text;
      document.body.appendChild(dom);
      var width = dom.getBoundingClientRect().width || dom.clientWidth;
      document.body.removeChild(dom);
      return width;
    }

    // 计算斜边
  }, {
    key: "computerSide",
    value: function computerSide(width) {
      this.height = Math.sin(Math.abs(this.rotate) * Math.PI / 180) * width;
      this.width = Math.sin((90 - Math.abs(this.rotate)) * Math.PI / 180) * width;
    }

    // 创建水印元素
  }, {
    key: "createDom",
    value: function createDom() {
      var waterDom = document.createElement('div');
      waterDom.setAttribute('style', "position: fixed;width: 100%;height: 100%;z-index: 100000;top: 70px;left:0;pointer-events: none;background-image: url(".concat(this.imageUrl, "), url(").concat(this.imageUrl, "); background-position: 80px 137px, 0 0;\n       background-repeat: repeat, repeat;\n       opacity: .05;\n       ").concat(this.style + ';'));
      waterDom.setAttribute('id', 'waterDom');
      return waterDom;
    }
  }, {
    key: "append",
    value: function append() {
      var dom = document.querySelector('#waterDom');
      if (dom) document.body.removeChild(dom);
      this.waterDom = this.createDom();
      document.body.appendChild(this.waterDom);
    }

    // 插入元素
  }, {
    key: "watcherDelWaterDom",
    value: function watcherDelWaterDom() {
      var _this = this;
      if (window.MutationObserver) {
        this.observer = new MutationObserver(function () {
          _this.append();
          _this.watch();
        });
        this.bodyObserver = new MutationObserver(function () {
          var dom = document.querySelector('#waterDom');
          if (!dom) return _this.append();
          _this.watch();
        });
      }
    }

    // 监听
  }, {
    key: "watch",
    value: function watch() {
      this.observer.observe(this.waterDom, {
        childList: true,
        // 观察目标子节点的变化，是否有添加或者删除
        attributes: true,
        // 观察属性变动
        subtree: true // 观察后代节点，默认为 false
      });

      this.bodyObserver.observe(document.body, {
        childList: true // 观察目标子节点的变化，是否有添加或者删除
      });
    }
  }]);
  return Watermark;
}();
export default Watermark;